__turbopack_context__.v({
  "button": "UpsellProduct-module__1NE7kW__button",
  "color": "UpsellProduct-module__1NE7kW__color",
  "image": "UpsellProduct-module__1NE7kW__image",
  "name": "UpsellProduct-module__1NE7kW__name",
  "price": "UpsellProduct-module__1NE7kW__price",
  "root": "UpsellProduct-module__1NE7kW__root",
  "sub": "UpsellProduct-module__1NE7kW__sub",
});
